import React from 'react'
import PropTypes from 'prop-types'

import { get, isString, noop } from 'lodash'
import { Button, Box, Paper } from '@material-ui/core'
import moment from 'moment'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/pro-regular-svg-icons'

import PlaceTypeahead from 'components/PlaceTypeahead'
import VisitRangeFilter from './VisitRangeFilter'

import MapListToggle from './MapListToggle'

import CategoryFilter from './CategoryFilter'
import VirtualFilter from './VirtualFilter'
import ClassSizeFilter from './ClassSizeFilter'

import { trackPlace, trackCategory, trackAvailability, trackClassSize, trackScoirSchools } from './analytics-helper'

export default class FilterBar extends React.Component {
  filterChange(value, trackingFn, removeOtherFilters) {
    trackingFn(value)
    let filters
    if (removeOtherFilters) {
      filters = value
    } else {
      filters = {
        ...this.props.filters,
        ...value,
      }
    }
    this.props.onChange(filters)
  }
  render() {
    const { filters } = this.props
    let to = get(filters, 'visitRange.to')
    let from = get(filters, 'visitRange.from')
    if (isString(to)) {
      to = moment(to)
    }
    if (isString(from)) {
      from = moment(from)
    }
    return (
      <Box
        component={Paper}
        display="flex"
        flexWrap="wrap"
        gridGap={8}
        alignItems="center"
        p={2}
      >
        <Box
          maxWidth="350px"
          width="100%"
        >
          <PlaceTypeahead
            onChange={(value, removeOtherFilters) => this.filterChange(value, trackPlace, removeOtherFilters)}
          />
        </Box>
        <Box>
          <CategoryFilter
            category={filters.category}
            onChange={(category) => this.filterChange({ category }, trackCategory)}
          />
        </Box>
        <Box>
          <Button
            startIcon={
              get(filters, 'isActive', false) ? (
                <FontAwesomeIcon
                  size="xs"
                  icon={faCheck}
                />
              ) : (
                ''
              )
            }
            color="primary"
            variant={get(filters, 'isActive', false) ? 'contained' : 'outlined'}
            onClick={() => this.filterChange({ isActive: !filters.isActive }, trackScoirSchools)}
          >
            Only Scoir Schools
          </Button>
        </Box>
        <Box>
          <ClassSizeFilter
            to={filters.maxSize}
            from={filters.minSize}
            onApply={(from, to) => this.filterChange({ minSize: from, maxSize: to }, trackClassSize)}
          />
        </Box>
        <Box>
          <VisitRangeFilter
            to={to}
            from={from}
            rangeType={get(filters, 'visitRange.type')}
            virtual={filters.virtual}
            onChange={(visitRange, virtual) => this.filterChange({ visitRange, virtual }, trackAvailability)}
          />
        </Box>
        <Box>
          <VirtualFilter
            virtual={filters.virtual}
            onChange={(virtual) => this.filterChange({ virtual }, noop)}
          />
        </Box>
        <Box marginLeft={{ xs: 'unset', lg: 'auto' }}>
          <MapListToggle></MapListToggle>
        </Box>
      </Box>
    )
  }
}

FilterBar.propTypes = {
  filters: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
}
